module.exports = __webpack_public_path__ + "img/lt-icone-email-moutarde.083a01dc.svg";